define('jquery-ui-helper',['require','jquery','jquery-ui/datepicker','jquery-ui/i18n/datepicker-en-AU','jquery-ui/i18n/datepicker-en-GB','jquery-ui/i18n/datepicker-es','jquery-ui/i18n/datepicker-de','jquery-ui/i18n/datepicker-it','jquery-ui/i18n/datepicker-fr','jquery-ui/i18n/datepicker-fr-CA','jquery-ui/i18n/datepicker-zh-CN'],function (require) {
    var $ = require('jquery');
    require('jquery-ui/datepicker');
    require('jquery-ui/i18n/datepicker-en-AU');
    require('jquery-ui/i18n/datepicker-en-GB');
    require('jquery-ui/i18n/datepicker-es');
    require('jquery-ui/i18n/datepicker-de');
    require('jquery-ui/i18n/datepicker-it');
    require('jquery-ui/i18n/datepicker-fr');
    require('jquery-ui/i18n/datepicker-fr-CA');
    require('jquery-ui/i18n/datepicker-zh-CN');

    /*
     * Loads datepicker locale corresponding to the argument, likely an i18n locale.
     * Will not load unless the locale matches exactly; try different variations of the locale.
     * Will default to American English.
     */
    var setDatepickerLocale = function (lang) {
        var locale = lang;
        var settings = $.datepicker.regional[locale];

        if (locale && !settings) {
            var primaryLocale = locale.substring(0, 2);
            settings = $.datepicker.regional[primaryLocale];
        }

        if (!settings) {
            // Defaults to American English if there are no matches.
            settings = $.datepicker.regional[''];
        }

        $.datepicker.setDefaults(settings);
        return settings;
    };

    return {
        setDatepickerLocale: setDatepickerLocale
    };
});

